import { render, staticRenderFns } from "./GroupsDate.vue?vue&type=template&id=45b996d9&"
import script from "./GroupsDate.vue?vue&type=script&lang=js&"
export * from "./GroupsDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports